<template>
  <v-card elevation="2">
    <div class="pa-4 mt-2">
      <v-card-title>
        <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
      </v-card-title>
      <v-data-table :headers="header" :items="data_list" key="index" :footer-props="footer_Props" :search="search" mobile-breakpoint="0">
        <template v-slot:item="dataDetail">
          <tr>
            <td>
              <div>{{ dataDetail.item.order_code }}</div>
            </td>
            <td>
              <div>{{ dataDetail.item.start_date }}</div>
            </td>
            <td>
              <div>{{ dataDetail.item.customer_name }}</div>
            </td>
            <td class="text-center">
              <div>{{ format_number(dataDetail.item.total) }}</div>
            </td>
            <td class="text-center">
              <div v-if="dataDetail.item.status === 1" style="color: #fdac39;">รอลูกค้าชำระเงิน</div>
              <div v-else-if="dataDetail.item.status === 3" style="color: red;">หลักฐานไม่ถูกต้อง</div>
              <div v-else-if="dataDetail.item.status === 2" style="color: #86bc3a;">ชำระเงินสำเร็จ</div>
              <div v-else-if="dataDetail.item.status === 4" style="color: #3988fd;">รอตรวจสอบสลิป</div>
              <div v-else>-</div>
            </td>
            <td class="pa-3 text-center">
              <v-btn class="pa-6 grad-success-bg white--text" @click="show_detail(dataDetail.item.id)">
                <v-icon>mdi-magnify</v-icon> ดูรายละเอียด
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </v-card>
</template>

<script>
import {formatNumber} from "@/js/handler";
import {HTTP} from "@/axios";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Transfer_from_debtor",
  data() {
    return {
      search: '',
      header: [
        {
          text: 'เลขที่วางบิล',
          value: 'order_code',
          fixed: true,
          width: '160px',
        },
        {
          text: 'วันที่ชำระ',
          value: 'start_date',
          fixed: true,
          width: '160px',
        },
        {
          text: 'ชื่อลูกค้า',
          value: 'customer_name',
          fixed: true,
          width: '200px',
        },
        {
          text: 'ยอดชำระหนี้',
          value: 'total',
          fixed: true,
          align: 'center',
          width: '160px',
        },
        {
          text: 'สถานะ',
          value: 'status',
          align: 'center',
          fixed: true,
          width: '200px',
        },
        {
          text: 'จัดการ',
          value: '',
          align: 'center',
          fixed: true,
          width: '160px',
        },
      ],
      data_list: [],
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
    }
  },
  methods: {
    format_number: function (value) {
      return formatNumber(value)
    },
    show_detail(id) {
      this.$router.push('/creditor/transferdebtordetail/' + id)
    },
    get_data() {
      this.loading_page = true
      HTTP.get('debtors/transfer_debtor')
          .then((res) => {
            if (res.data.success === true) {
              this.data_list = res.data.object.orderlists
            }
          })
    },
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>

</style>
